if (!customElements.get('grouped-products')) {
  customElements.define(
    'grouped-products',
    class GroupedProducts extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      init(attempt = 0) {
        // Swiper is loaded globally (deferred) from theme.liquid; wait for it.
        if (typeof Swiper === 'undefined') {
          if (attempt < 50) setTimeout(() => this.init(attempt + 1), 100);
          return;
        }
        if (this.swiper) return;

        const el = this.querySelector('.grouped-products__slider');
        if (!el) return;
        const gap = parseInt(this.dataset.gap, 10) || 0;
        const mobile = parseFloat(this.dataset.mobile) || 2;
        const desktop = parseFloat(this.dataset.desktop) || 4;
        const arrows = this.dataset.arrows === 'true';
        const pagination = this.dataset.pagination === 'true';

        const pagEl = this.querySelector('.grouped-products__pagination');
        if (pagEl) pagEl.style.display = pagination ? '' : 'none';

        this.swiper = new Swiper(el, {
          initialSlide: parseInt(this.dataset.activeIndex, 10) || 0,
          slidesPerView: mobile,
          spaceBetween: gap,
          watchOverflow: true,
          grabCursor: true,
          breakpoints: { 750: { slidesPerView: desktop, spaceBetween: gap } },
          navigation: arrows
            ? { prevEl: this.querySelector('.grouped-products__prev'), nextEl: this.querySelector('.grouped-products__next') }
            : false,
          pagination: pagination ? { el: pagEl, clickable: true } : false,
        });
      }
    }
  );
}
